// Define the interface for Raw Material Details
export interface IRawMaterialDetails {
  rawMaterialId?: string; // Added for API response mapping
  scProductRawMaterialCode: string; // Dropdown field (required)
  scProductRawMaterialCodeDescription: string; // Description for scProductRawMaterialCode dropdown
  scProductRawMaterialUserSpecificTerm: string; // Text field (optional)
}

// Define the interface for API Response
export interface IRawMaterialDetailsResponse {
  scId: string;
  rawMaterialId: string;
  scProductRawMaterialCode: string;
  scProductRawMaterialCodeDescription: string;
  scProductRawMaterialUserSpecificTerm: string;
}

export interface IRawMaterialDetailsApiResponse {
  response: IRawMaterialDetailsResponse[];
  no_of_records: number;
}

export const mapRawMaterialDetailsPayload = (jsonData: any, scId: string) => {
  return {
    scId: scId,
    rawMaterialId: jsonData.rawMaterialId,
    scProductRawMaterialCode: jsonData.scProductRawMaterialCode,
    scProductRawMaterialCodeDescription: jsonData.scProductRawMaterialCodeDescription || "",
    scProductRawMaterialUserSpecificTerm: jsonData.scProductRawMaterialUserSpecificTerm || "",
  };
};

export const initialRawMaterialDetails: IRawMaterialDetails = {
  scProductRawMaterialCode: "",
  scProductRawMaterialCodeDescription: "",
  scProductRawMaterialUserSpecificTerm: "",
};

export const mapRawMaterialDetailsApiResponseToInitialValues = (response: any) => {
  return {
    rawMaterialId: response?.rawMaterialId || "",
    scProductRawMaterialCode: response?.scProductRawMaterialCode || "",
    scProductRawMaterialCodeDescription: response?.scProductRawMaterialCodeDescription || "",
    scProductRawMaterialUserSpecificTerm: response?.scProductRawMaterialUserSpecificTerm || "",
  };
};
